module.exports = __webpack_public_path__ + "static/img/s19.35e93d53.png";